import { useState, useEffect, useCallback } from 'react';
import { api } from '../api/client';

interface User {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  role: string;
  access_tier: string;
  verification_status: string | null;
  tenant: {
    id: string;
    name: string;
    slug: string;
  };
}

interface AuthState {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
}

export function useAuth() {
  const [state, setState] = useState<AuthState>({
    user: null,
    isLoading: true,
    isAuthenticated: false,
  });

  useEffect(() => {
    api.loadFromStorage();
    api.getCurrentUser()
      .then((user) => {
        setState({ user, isAuthenticated: true, isLoading: false });
      })
      .catch(() => {
        api.clearAuth();
        setState({ user: null, isAuthenticated: false, isLoading: false });
      });
  }, []);

  const login = useCallback(async (email: string, password: string, tenantSlug: string) => {
    const data = await api.login(email, password, tenantSlug);
    setState({
      user: data.user,
      isLoading: false,
      isAuthenticated: true,
    });
    return data;
  }, []);

  const logout = useCallback(async () => {
    await api.logout();
    setState({
      user: null,
      isLoading: false,
      isAuthenticated: false,
    });
  }, []);

  return { ...state, login, logout };
}
